import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/helpers/auth.service";
import { CoreService } from "src/app/core/helpers/core.service";
import { DataServiceService } from "src/app/core/helpers/data-service.service";
import { GaService } from "src/app/core/helpers/ga.service";

@Component({
  selector: "loyaltic-upload-receipt",
  templateUrl: "./upload-receipt.component.html",
  styleUrls: ["./upload-receipt.component.scss"],
})
export class UploadReceiptComponent implements OnInit {
  receipt: any;
  Quantity = 1;
  receiptSrc: any;
  removeLocalProductList = true;
  ReceiptName = "";
  culture = "";
  product1 = null;
  product2 = null;
  product3 = null;
  product4 = null;
  product5 = null;
  prodQuantityOne = 0;
  prodQuantityTwo = 0;
  prodQuantityThree = 0;
  prodQuantityFour = 0;
  prodQuantityFive = 0;
  List = [];
  @ViewChild("tryagainReceiptUpload", { static: false })
  tryagainReceiptUploadRef: any;
  @ViewChild("uploadAnimation", { static: false }) uploadAnimationRef: any;
  @ViewChild("thankyouApprovedPopup", { static: false }) thankyouApprovedPopupRef: any;
  @ViewChild("uploadHelp", { static: false }) uploadHelpPopupRef: any;
  public modalRef: BsModalRef;

  showConfirmReceiptUploadPopUp = false;
  @Output() receiptUploadSuccess = new EventEmitter<any>();

  popupConfig = {
    ignoreBackdropClick: true,
    class:
      "lyltc animation modal-md modal-dialog-centered modal-dialog-animation",
  };

  confirmPopupConfig = {
    ignoreBackdropClick: true,
    class: "lyltc modal-md modal-dialog-centered",
  };
  showSurvey = true;
  IsKotiPizzaStore = false;
  isFinnish = false;
  productList: any;
  productQuantity = new Array(10);
  selectedProducts = [
    {productId: '', productName:'', quantity: 0}
  ]

  showSurveyScript=false;

  constructor(
    private authService: AuthService,
    private coreService: CoreService,
    private toast: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private dataService: DataServiceService,
    private modalService: BsModalService,
    private gaService: GaService
  ) {
    this.culture = translate.getDefaultLang();
    if (this.culture == 'fi-FI') {
      this.isFinnish = true;
    }
  }

  ngOnInit() {
    if (localStorage.getItem("surveyTaken") == "true") {
      this.showSurvey = false;
    }

    this.coreService.getProducts().then((res: any) => {
      console.log('producs', res.result.purchasedProducts);
      this.productList = res.result.purchasedProducts;
      if (localStorage.getItem('productList')) {
        let storedProducts = JSON.parse(localStorage.getItem('productList'));
        if (storedProducts.length > 0) {
          this.selectedProducts  = [];
          storedProducts.map((product:any) => {
            let data = {
              productId: product.ProductId,
              productName : product.ProductName,
              quantity: product.Quantity
            }
            this.selectedProducts.push(data);
          })
        }
  
      }
    })
  }

  // onReceiptSelect(event) {
  //   this.receipt = event.target.files[0];
  // }
  
  onReceiptSelect(event) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement("img");
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }
  openProductHelp() {
    this.modalRef = this.modalService.show(
      this.uploadHelpPopupRef,
      this.popupConfig = {
        ignoreBackdropClick: false,
        class:
          "lyltc animation modal-md modal-dialog-centered modal-dialog-animation",
      }
    );
  }
  showAnimationPopup() {
    this.modalRef = this.modalService.show(
      this.uploadAnimationRef,
      this.popupConfig
    );
  }

  onProductSelect(name: string, index: number) {
    const product = this.productList && this.productList.find((p: any) => p.name === name);
    this.selectedProducts[index].productId = product ? product.productId : '';
  }

  addMoreProduct() {
    let prod = {productId: '', productName:'', quantity: 0};
    this.selectedProducts.push(prod);
  }

  removeProductAt(index: number) {
    this.selectedProducts.splice(index, 1);
  }

  onReceiptUpload(form) {
    const userId = this.authService.getUserId();
    const IsReUpload = localStorage.getItem('IsReUpload');
    this.List = [];

    this.selectedProducts.map((prod:any) => {
      let product = this.productList.filter((produ:any) => produ.name === prod.productName)[0];
      let data = {
        'ProductId': prod.productId,
        'ProductName': prod.productName,
        'Quantity': prod.quantity,
        'PointsPerProduct': product.pointsPerProduct
      }
      this.List.push(data);
    })

    this.showAnimationPopup();

    
    localStorage.setItem('productList', JSON.stringify(this.List));
    const formData = new FormData();
    formData.append("UserId", userId);
    formData.append("Quantity", this.Quantity.toString());
    formData.append("Culture", this.translate.getDefaultLang());
    formData.append("File", this.receipt);
    formData.append("IsReUpload", IsReUpload === "1" ? "true" : "false");
    formData.append("Purchases", JSON.stringify(this.List));

    if (this.isFinnish) {
      formData.append("IsKotiPizzaStore", this.IsKotiPizzaStore ? "true" : "false");
    }

    this.coreService
      .upLoadReceipt(formData)
      .then((res: any) => {
        localStorage.removeItem('modalDisplayed')
        this.modalRef.hide();
        form.submitted = false;
        this.resetForm();
        //this.toast.success(this.translate.instant('' + res.messageKey), this.translate.instant('success'));
        this.receiptUploadSuccess.emit(res.result);

        this.gaService.emitEvent("upload_receipt", "Upload Screen");
        
        this.coreService.rejectedReasons = res.feedbackMessages;


        if (!res.result.isapproved && res.result.tryagain) {
          this.removeLocalProductList  = false;
          this.modalRef = this.modalService.show(
            this.tryagainReceiptUploadRef,
            this.confirmPopupConfig
          );
          return;
        }

        if (
          !res.result.isapproved &&
          res.result.recptPartitionKey &&
          res.result.recptRowKey
        ) {
          this.removeLocalProductList = false;
          //this.authService.setToken(res.result.token, res.result.id);
          this.dataService.setReceiptNotApprovedData(res.result);
          this.showConfirmReceiptUploadPopUp = true;
          return;
        }
        if (res.result.isapproved) {
          localStorage.removeItem('productList');
          localStorage.setItem("IsReUpload", "0");
          this.modalRef = this.modalService.show(this.thankyouApprovedPopupRef, this.confirmPopupConfig);
        }
      })
      .catch((errorResponse: any) => {
        // this.resetForm();
        const errorMessage = this.translate.instant(
          errorResponse.error.messageKey
        );
        this.toast.error(errorMessage, "");
        return;
      });
  }

  tryAgain() {
    this.resetForm();
    this.modalRef.hide();
    this.router.navigateByUrl(this.getMarketPath("upload"));
  }

  goHome() {
    this.resetForm();
    this.modalRef.hide();
    this.router.navigateByUrl(this.getMarketPath());
  }

  resetForm() {
    this.ReceiptName = "";
    this.Quantity = 1;
    this.receipt = undefined;
    this.selectedProducts = [{ productId: '', productName: '', quantity: 0 }];
    this.List = [];
  }

  surveyTaken() {
    localStorage.setItem("surveyTaken", "true");
    this.showSurvey = false;
  }

  ngOnDestroy() {
    if (this.removeLocalProductList) {
      localStorage.removeItem('productList');
    }
  }

  private getMarketPath(path = ""): string {
    const prefix = this.getCurrentMarketPrefix();
    const normalizedPath = path ? "/" + path.replace(/^\/+/, "") : "";

    return prefix ? "/" + prefix + normalizedPath : normalizedPath || "/";
  }

  private getCurrentMarketPrefix(): string {
    const routerPrefix = this.getFirstPathSegment(this.router.url);

    if (routerPrefix === "se" || routerPrefix === "fi") {
      return routerPrefix;
    }

    const windowPrefix = this.getFirstPathSegment(window.location.pathname);

    return windowPrefix === "se" || windowPrefix === "fi" ? windowPrefix : "";
  }

  private getFirstPathSegment(url: string): string {
    return (url || "").split("?")[0].split("#")[0].split("/").filter(Boolean)[0] || "";
  }

   onShowSurveyScritptClick() {
    this.showConfirmReceiptUploadPopUp = false;
    this.showSurveyScript = true;
  }
}
